export var LoyaltyTierLevel;
(function (LoyaltyTierLevel) {
    LoyaltyTierLevel["basic"] = "basic";
    LoyaltyTierLevel["premium"] = "premium";
    LoyaltyTierLevel["deluxe"] = "deluxe";
})(LoyaltyTierLevel || (LoyaltyTierLevel = {}));
export var LoyaltyCurrencyType;
(function (LoyaltyCurrencyType) {
    LoyaltyCurrencyType["nonQualifying"] = "NonQualifying";
    LoyaltyCurrencyType["qualifying"] = "Qualifying";
})(LoyaltyCurrencyType || (LoyaltyCurrencyType = {}));
//# sourceMappingURL=loyalty.js.map